import ApiRequest from './ApiRequest';


class PaginationApiRequest extends ApiRequest {}


export default PaginationApiRequest;
